export default function isValidDiscountCount(count, qty, interval) {
  if (interval === 0) {
    return (count === qty)
  }
  if (count < qty) {
    return false
  }
  return (((count - qty) % interval) === 0)
}
